<template>
	<div class="px-3">
		<div class="box has-text-centered">
			<img src="@/assets/images/jobs/claim-success.gif"/>
			<br />
			<span class="bold-text">Yay! You’ve successfully claimed this job</span>
			<br />
			<br />
			<span>View job info and next steps by clicking below.</span>
			<br />
			<br />
			<span class="is-underlined is-clickable view-job" @click="close()">View Job Details</span>
		</div>
	</div>
	
</template>

<script lang="ts">
import { closeModal } from '@/utils/mixins';
import { defineComponent } from 'vue'

export default defineComponent({
	mixins: [closeModal]
})
</script>

<style scoped>
	img{
		max-width: 150px;
	}

	.view-job{
		color: #3983D3;
	}
</style>
